var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 365.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#18174a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.51,10.85A35.09,35.09,0,0,0,198.81,0H52.64a35.13,35.13,0,0,0-25.7,10.85A35.13,35.13,0,0,0,16.09,36.54V328.9a35.13,35.13,0,0,0,10.85,25.7,35.13,35.13,0,0,0,25.7,10.85H198.81a37.06,37.06,0,0,0,36.55-36.55V36.54A35.13,35.13,0,0,0,224.51,10.85ZM102.88,36.54h45.69c3.05,0,4.56,1.53,4.56,4.57s-1.52,4.57-4.56,4.57H102.88q-4.56,0-4.56-4.57C98.32,38.07,99.84,36.54,102.88,36.54Zm39,308.5a22.75,22.75,0,1,1,6.71-16.14A22,22,0,0,1,141.86,345ZM208,283.23a9.26,9.26,0,0,1-9.13,9.13H52.64a9.26,9.26,0,0,1-9.14-9.13v-201a9.27,9.27,0,0,1,9.14-9.14H198.81A9.27,9.27,0,0,1,208,82.23v201h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon_5.6869989ea2d59b139a251191ecbaf5fd.svg";
export { ForwardRef as ReactComponent };